import clsx from 'clsx';
import { bool, shape, string } from 'prop-types';

import { AlertBanner, Skeleton, StrapiImg } from 'components';

const HeroBanner = ({ title, image, mobileImage, loading = false, className = '' }) => {
  return (
    <div className={clsx('hero-banner header-gradient', className)}>
      {loading ? (
        <Skeleton type="text" classNames="w-full h-full" />
      ) : (
        <>
          <StrapiImg image={image} mobileImage={mobileImage} />

          <AlertBanner />

          {title && (
            <div className="main-container w-full absolute bottom-12">
              <div className="banner-title">
                <h1 className="h1 text-base md:text-xl lg:text-2xxl">{title}</h1>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

HeroBanner.propTypes = {
  image: shape({ url: string, alternativeText: string }),
  mobileImage: shape({ url: string, alternativeText: string }),
  loading: bool,
  title: string,
  className: string
};

export default HeroBanner;
